import React from 'react';

class Timeline extends React.Component {
  render() {
    return (
      <>
        <h3>
          <i className='fa fa-graduation-cap' aria-hidden='true'></i>
          {this.props && this.props.Body_data
            ? '  ' + this.props.Body_data.heading
            : null}
        </h3>
        <div className='timeline-wrapper'>
          <div className='timeline'>
            {this.props.Body_data
              ? this.props.Body_data.list_school.reverse().map((data) => (
                  <div key={data.year} className={data.class}>
                    <div className='content'>
                      <h2 style={{ marginLeft: '10px' }}>{data.year}</h2>
                      <p style={{ marginLeft: '10px' }}>{data.school}</p>
                      <p style={{ marginLeft: '10px' }}>{data.course}</p>
                    </div>
                  </div>
                ))
              : null}
          </div>
        </div>
      </>
    );
  }
}

export default Timeline;
